import { HP_COMPETITOR_ID, OTHER_COMPETITOR_ID } from 'partner360/features/competitorsSob/constants'
import { ISobCompetitor } from 'partner360/models/ISobCompetitor'

export const getSelectedCompetitors = (competitors: ISobCompetitor[]) => {
  return competitors
    .reduce((acc, item) => {
      if (item.CompetitorID === HP_COMPETITOR_ID || item.CompetitorID === OTHER_COMPETITOR_ID) {
        return acc
      }
      if (acc.includes(item.CompetitorID)) {
        return acc
      }

      return [...acc, item.CompetitorID]
    }, [] as string[])
    .map((item) => ({ CompetitorID: item }))
}
